import React, { useEffect, useLayoutEffect, useState } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { CHART_COLORS_TWO } from 'constant/variables';

am4core.useTheme(am4themes_animated);

export default function Clustered2(props) {
  const [viewData, setViewData] = useState([]);
  const {empper} = props;
   useEffect(() => {
    if (empper) {
      if (empper.length === 0) {
        const viewDetail = [];
        const details = {
          category: "Not Available",
          first: 0,
          second: 0
        };
        viewDetail.push(details);
        setViewData(viewDetail);
      } else {
        const clinic = empper;
        const viewDetail = [];
        for (let index = 0; index < clinic.length; index++) {
          var text = clinic[index].Name
          const myArray = text.split(" ");
          const Name1 = `${myArray[0]} ${myArray[1]}`
          console.log(Name1)
          const details = {
            year: Name1,
            income: parseInt(clinic[index].TotalAchievedPercentage),
            expenses: parseInt(clinic[index].TotalTarget)
          };
          viewDetail.push(details);
        }

        setViewData(viewDetail);
      }
    }
  }, [empper]);

  useLayoutEffect(() => {
    // var chart = am4core.create('chartdiv9', am4charts.XYChart)
    var chart = am4core.create("chartdiv9", am4charts.XYChart);

// Add data\
chart.data = viewData
// chart.data = [{
//   "year": 2005,
//   "income": 23.5,
//   "expenses": 18.1
// },{
//   "year": 2006,
//   "income": 26.2,
//   "expenses": 22.8
// },{
//   "year": 2007,
//   "income": 30.1,
//   "expenses": 23.9
// },{
//   "year": 2008,
//   "income": 29.5,
//   "expenses": 25.1
// },{
//   "year": 2009,
//   "income": 24.6,
//   "expenses": 25
// }];

// Create axes
var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
categoryAxis.dataFields.category = "year";
categoryAxis.numberFormatter.numberFormat = "#";
categoryAxis.renderer.inversed = true;
categoryAxis.renderer.grid.template.location = 0;
categoryAxis.renderer.cellStartLocation = 0.1;
categoryAxis.renderer.cellEndLocation = 0.9;

var  valueAxis = chart.xAxes.push(new am4charts.ValueAxis()); 
valueAxis.renderer.opposite = true;

// Create series
function createSeries(field, name) {
  var series = chart.series.push(new am4charts.ColumnSeries());
  series.dataFields.valueX = field;
  series.dataFields.categoryY = "year";
  series.name = name;
  series.columns.template.tooltipText = "{name}: [bold]{valueX}[/]";
  series.columns.template.height = am4core.percent(100);
  series.sequencedInterpolation = true;

  var valueLabel = series.bullets.push(new am4charts.LabelBullet());
  valueLabel.label.text = "{valueX}";
  valueLabel.label.horizontalCenter = "left";
  valueLabel.label.dx = 10;
  valueLabel.label.hideOversized = false;
  valueLabel.label.truncate = false;

  var categoryLabel = series.bullets.push(new am4charts.LabelBullet());
  categoryLabel.label.text = "{name}";
  categoryLabel.label.horizontalCenter = "right";
  categoryLabel.label.dx = -10;
  categoryLabel.label.fill = am4core.color("#fff");
  categoryLabel.label.hideOversized = false;
  categoryLabel.label.truncate = false;
}

// Modify chart's colors
chart.colors.list = CHART_COLORS_TWO;

createSeries("income", "Achievememt %");
createSeries("expenses", "Target");

    return () => {
      chart.dispose();
    };
  }, [viewData]);

  return <div id="chartdiv9" style={{ width: '100%', height: '500px' }} />;
}
